module.exports = __webpack_public_path__ + "static/media/video_upload.6f895e79.svg";